import { a as __makeTemplateObject, _ as __assign } from './tslib.es6-86dc5b0c.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { and, uiTypeIs, schemaTypeIs, rankWith } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { S as SvgInputError } from './InputError-721475be.js';
import { S as SvgLightBulbTip } from './LightBulbTip-46b25295.js';
import styled, { css } from 'styled-components';
import { d as descriptionCapsize, h as headingLowerCapsize } from './typography-fe8ea2dd.js';
import { S as SimpleMarkdown } from './SimpleMarkdown-107c346a.js';

var iconToComponentMap = {
    inputError: SvgInputError,
    lightBulbTip: SvgLightBulbTip,
};

css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 24px;\n  margin-right: 10px;\n  width: 21px;\n\n  ", "\n"], ["\n  height: 24px;\n  margin-right: 10px;\n  width: 21px;\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    [data-svg-class='Clock-stroke'] {\n      stroke: ", ";\n    }\n\n    [data-svg-class='InputError-stroke'] {\n      stroke: ", ";\n    }\n  "], ["\n    [data-svg-class='Clock-stroke'] {\n      stroke: ", ";\n    }\n\n    [data-svg-class='InputError-stroke'] {\n      stroke: ", ";\n    }\n  "])), theme.topForegroundPrimary, theme.bottomBackgroundColor);
});
var Description = styled.p(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n\n  margin: 1rem 0 0 0;\n\n  ", "\n\n  ", "\n"], ["\n  ", ";\n\n  margin: 1rem 0 0 0;\n\n  ", "\n\n  ", "\n"])), descriptionCapsize, function (_a) {
    var theme = _a.theme;
    return "\n    color: " + theme.bottomForegroundPrimary + ";\n  ";
}, function (_a) {
    var align = _a.align;
    switch (align) {
        case 'center':
            return 'text-align: center;';
        case 'left':
            return 'text-align: left;';
        default:
            return '';
    }
});
var IconContainer = styled.div(function (_a) {
    var hasDescription = _a.hasDescription;
    return "\n margin-bottom: " + (hasDescription ? '1rem' : 0) + "\n";
});
var JsonFormsNullControlBase = styled.section(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: 0;\n  padding: 10px 0 0 0;\n"], ["\n  margin: 0;\n  padding: 10px 0 0 0;\n"])));
var JsonFormsNullControlImage = styled.img(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: block;\n  height: auto;\n  margin: 0 auto;\n  width: auto;\n\n  ", "\n"], ["\n  display: block;\n  height: auto;\n  margin: 0 auto;\n  width: auto;\n\n  ", "\n"])), function (_a) {
    var imageSize = _a.imageSize;
    switch (imageSize) {
        case 'small':
            return 'max-width:330px; max-height:220px;';
        case 'medium':
            return 'max-width:430px; max-height:320px;';
        case 'large':
            return 'max-width:530px; max-height:420px;';
        default:
            return 'max-width: 430px; max-height: 320px';
    }
});
var JsonFormsNullControlImageContainer = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: block;\n  text-align: center;\n"], ["\n  display: block;\n  text-align: center;\n"])));
var SubheadLayout = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  align-items: center;\n  display: grid;\n  grid-column-gap: 9px;\n  grid-template-columns: auto auto;\n  justify-content: flex-start;\n\n  ", "\n"], ["\n  align-items: center;\n  display: grid;\n  grid-column-gap: 9px;\n  grid-template-columns: auto auto;\n  justify-content: flex-start;\n\n  ", "\n"])), function (_a) {
    var align = _a.align;
    switch (align) {
        case 'center':
            return 'justify-content: center;';
        case 'left':
            return 'justify-content: left;';
        default:
            return 'justify-content: left;';
    }
});
var Subhead = styled.h2(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", ";\n\n  margin: 0;\n  text-align: left;\n\n  ", "\n\n  ", "\n"], ["\n  ", ";\n\n  margin: 0;\n  text-align: left;\n\n  ", "\n\n  ", "\n"])), headingLowerCapsize, function (_a) {
    var theme = _a.theme;
    return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme.bottomForegroundPrimary);
}, function (_a) {
    var align = _a.align;
    switch (align) {
        case 'center':
            return 'text-align: center;';
        case 'left':
            return 'text-align: left;';
        default:
            return 'text-align: left;';
    }
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;

var isNullControl = and(uiTypeIs('Control'), schemaTypeIs('null'));
var jsonFormsNullControlTester = rankWith(3, isNullControl);
/**
 * Null Control to be used as a renderer in the `JsonForms` component.
 *
 * @example
 *
 * <JsonForms
 *   renderers={[
 *     {
 *       renderer: JsonFormsNullControl,
 *       tester: jsonFormsNullControlTester,
 *     },
 *   ]}
 * ></JsonForms>
 */
var JsonFormsNullControl = withJsonFormsControlProps(function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var label = _a.label, uischema = _a.uischema, visible = _a.visible;
    if (!visible) {
        return null;
    }
    var description = (_b = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _b === void 0 ? void 0 : _b.description;
    var icon = (_c = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _c === void 0 ? void 0 : _c.icon;
    var IconComponent = iconToComponentMap[icon];
    var align = (_d = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _d === void 0 ? void 0 : _d.align;
    var format = (_f = (_e = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _e === void 0 ? void 0 : _e.format) !== null && _f !== void 0 ? _f : 'text';
    var imageSize = (_h = (_g = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _g === void 0 ? void 0 : _g.imageSize) !== null && _h !== void 0 ? _h : 'medium';
    var labelIsDesc = !!((_j = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _j === void 0 ? void 0 : _j.labelIsDesc);
    var imageSrc = (_l = (_k = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _k === void 0 ? void 0 : _k.imageSrc) !== null && _l !== void 0 ? _l : '';
    var LabelContainer = function () {
        if (labelIsDesc) {
            return jsx(Description, __assign({ align: align }, { children: label }), void 0);
        }
        return jsx(Subhead, __assign({ align: align }, { children: label }), void 0);
    };
    return (jsxs(Fragment, { children: [format === 'text' && (jsx(JsonFormsNullControlBase, { children: jsxs(SubheadLayout, __assign({ align: align }, { children: [icon ? (jsx(IconContainer, __assign({ hasDescription: !!description }, { children: jsx(IconComponent, {}, void 0) }), void 0)) : null, jsxs("div", { children: [label && jsx(LabelContainer, {}, void 0), description && (jsx(Description, { children: jsx(SimpleMarkdown, { children: description }, void 0) }, void 0))] }, void 0)] }), void 0) }, void 0)), format === 'image' && (jsx(JsonFormsNullControlBase, { children: jsx(JsonFormsNullControlImageContainer, { children: jsx(JsonFormsNullControlImage, { alt: "", imageSize: imageSize, src: imageSrc }, void 0) }, void 0) }, void 0))] }, void 0));
});

export { JsonFormsNullControl as J, jsonFormsNullControlTester as j };
